import { Customer } from './customer';
import { Location } from './location';

export type Contract = {
  id: number;
  /** Date string */
  startDate: string;
  /** Date string */
  endDate?: string;
  active: boolean;
  customer: Customer;
  location: Location;
  unitSizeType: string;
  // Number of days to not charge daily rates for
  freeDays: number;

  // Empty storage rates, container and chassis
  // Price to charge per non-free day
  dailyEmpty: number;
  // Charge at gate in
  gateInEmpty: number;
  // Charge at gate out
  gateOutEmpty: number;

  // Empty container only
  dailyEmptyContainer: number;
  gateInEmptyContainer: number;
  gateOutEmptyContainer: number;
  // Charge to lift container off chassis for storage
  liftOffEmpty: number;
  // Charge to put container on chassis for withdrawal
  liftOnEmpty: number;
  // Cost per container moved in digs
  digEmpty: number;

  // Chassis only
  dailyChassis: number;
  gateInChassis: number;
  gateOutChassis: number;

  // Loaded containers
  // Regular free days don't apply to loaded containers
  freeDaysLoaded: number;
  dailyLoaded: number;
  gateInLoaded: number;
  gateOutLoaded: number;
  liftOffLoaded: number;
  liftOnLoaded: number;
  digLoaded: number;
};

export const defaultContract = (): Contract => {
  let date = new Date();
  date.setDate(1);
  return {
    id: 0,
    startDate: date.toISOString(),
    active: true,
    customer: {} as Customer,
    location: {} as Location,
    unitSizeType: '',
    freeDays: 0,
    dailyEmpty: 0,
    gateInEmpty: 0,
    gateOutEmpty: 0,
    dailyEmptyContainer: 0,
    gateInEmptyContainer: 0,
    gateOutEmptyContainer: 0,
    liftOffEmpty: 0,
    liftOnEmpty: 0,
    digEmpty: 0,
    dailyChassis: 0,
    gateInChassis: 0,
    gateOutChassis: 0,
    freeDaysLoaded: 0,
    dailyLoaded: 0,
    gateInLoaded: 0,
    gateOutLoaded: 0,
    liftOffLoaded: 0,
    liftOnLoaded: 0,
    digLoaded: 0
  };
};
